// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-field__title {\n  font-size: 18px;\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n.profile-field__title--required:after {\n    content: \"*\";\n    color: red;\n    display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
